<div class="page-content">
    <form [formGroup]="postTripRequestForm">
        <mat-stepper [selectedIndex]="activeStepperIndex" orientation="vertical" animationDuration="0ms" #stepper >
            <mat-step>
                <ng-template matStepLabel>Appointment Date</ng-template>
                <app-mobile-appointment [tripType]="'Post'"></app-mobile-appointment>
                <div class="appointment-button">
                    <button type="button"  mat-button (click)="goToDriverInfo(stepper, 'Next')">Next</button>
                </div>               
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Driver Information</ng-template>
                <app-mobile-trip-driver></app-mobile-trip-driver>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"   mat-button (click)="goToAppointment(stepper)">Back</button></div>
                    <div class="right-button">
                        <button type="button"   mat-button (click)="goToTripLocation(stepper, 'Next')">Next</button>
                    </div>                   
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Trip Location</ng-template>
                <app-mobile-trip-location></app-mobile-trip-location>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"  mat-button (click)="goToDriverInfo(stepper, 'Back')">Back</button></div>
                    <div class="right-button">
                        <button type="button"   mat-button (click)="goToPassenger(stepper, 'Next')">Next</button>
                    </div>                   
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Passenger Information</ng-template>
                <app-mobile-trip-passenger></app-mobile-trip-passenger>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"   mat-button (click)="goToTripLocation(stepper, 'Back')">Back</button></div>
                    <div class="right-button">
                        <button type="button"   mat-button (click)="goToDocuments(stepper, 'Next')">Next</button>
                    </div>                   
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Document Upload</ng-template>
                <app-mobile-trip-document></app-mobile-trip-document>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"  mat-button (click)="goToPassenger(stepper, 'Back')">Back</button></div>
                    <div class="right-button">
                        <button type="button"   mat-button (click)="goToSummary(stepper, 'Next')">Next</button>
                    </div>                   
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Summary</ng-template>
                <app-mobile-trip-summary [tripType]="'Post'"></app-mobile-trip-summary>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"  mat-button (click)="goToDocuments(stepper, 'Back')">Back</button></div>
                    <div class="right-button">
                        <button type="submit"   mat-button (click)="saveTripSumary()">Submit</button>
                    </div>                   
                </div>
            </mat-step>
        </mat-stepper>
    </form>
</div>

<ng-template #confirmationDialogTemplate>
  <div class="access-dialogue">
    <div mat-dialog-title class="dialog-title-center">
        <span>{{dialogTitle}}</span>
    </div>
    <mat-dialog-content>
      <p>{{dialogContent}}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions-center">
      <button mat-flat-button color="primary" (click)="closeDialog()" aria-label="Continue to next step">OK</button>
    </mat-dialog-actions>
  </div>
</ng-template>